export class RateCardStatus {

    private status: string;
    private message: string;

    constructor(raw: any) {
        if (raw) {
            this.setStatus(raw.status);
            this.setMessage(raw.message);
        }
    }

    public getStatus(): string {
        return this.status;
    }

    public setStatus(status: string): void {
        this.status = status;
    }

    public getMessage(): string {
        return this.message;
    }

    public setMessage(message: string): void {
        this.message = message;
    }

}